import { defineMessages } from 'react-intl';

export default defineMessages({
    claimRelatedHeading: {
        id: 'claim-related.claimRelatedHeading',
        defaultMessage: 'View claim-related documents'
    },
    claimRelatedPart1: {
        id: 'claim-related.claimRelatedPart1',
        defaultMessage: 'You can now see claim-related documents online, including '
    },
    claimRelatedPart2Link: {
        id: 'claim-related.claimRelatedPart2Link:',
        defaultMessage: 'documents you’ve submitted'
    },
    claimRelatedPart2AriaLabel: {
        id: 'claim-related.claimRelatedPart2AriaLabel',
        defaultMessage: 'View claim-related documents you’ve submitted online'
    },
    claimRelatedPart3: {
        id: 'claim-related.claimRelatedPart3',
        defaultMessage: 'Your information is secure and protected under the '
    },
    claimRelatedPart4Link: {
        id: 'claim-related.claimRelatedPart4Link',
        defaultMessage: 'Freedom of Information and Protection of Privacy Act (FIPPA)'
    },
    claimRelatedPart4AriaLabel: {
        id: 'claim-related.claimRelatedPart4AriaLabel',
        defaultMessage: 'Learn about the Freedom of Information and Protection of Privacy Act and how your information is protected'
    },
    claimRelatedHistoryremoveDocText: {
        id: 'claim-related.removeDoc',
        defaultMessage: 'Need to remove a document you submitted? ',
    },
    claimRelatedHistorysendMessage: {
        id: 'claim-related.sendMessage',
        defaultMessage: 'Send us a message',
    },
    claimRelatedHistorysendMessageEnd: {
        id: 'claim-related.sendMessageEnd',
        defaultMessage: '.',
    },
    faqLink: {
        id: 'claim-related.faqLink',
        defaultMessage: 'frequently asked questions',
    },
    claimRelatedfaqcontent:{
        id:'claim-related.faqContent',
        defaultMessage: 'We’ll be making more types of documents available soon. For more information, check out our '
    },
    claimRelatedPart5: {
        id: 'claim-related.claimRelatedPart5',
        defaultMessage: '.'
    },
    btnResetDefault: {
        id: 'claim-related.btnResetDefault',
        defaultMessage: 'Reset'
    },
    btnSearchFilter: {
        id: 'claim-related.btnSearchFilter',
        defaultMessage: 'Search'
    },
    findSubmittedDocuments: {
        id: 'claim-related.findSubmittedDocuments',
        defaultMessage: 'Find claim-related documents'
    },
    findSubmittedParagraph: {
        id: 'claim-related.findSubmittedParagraph',
        defaultMessage: 'Your newest documents appear at the top of the table. '
    },
    findSubmittedText: {
        id: 'claim-related.findSubmittedText',
        defaultMessage: 'Click the document description to view or download the document. Finish downloading your selection before starting a new search. '
    },
    findSubmittedText1: {
        id: 'claim-related.findSubmittedText1',
        defaultMessage: 'When downloading multiple files, you may need to click ’allow’ if your browser prompts you. If some of the files don’t download on your phone or tablet, try downloading them one at a time, or use a computer. '
    },
    findSubmittedText2: {
        id: 'claim-related.findSubmittedText2',
        defaultMessage: 'If you’ve sent us a document by mail, it may take up to 10 business days to appear. Documents sent by fax usually take about five business days to appear.'
    },
    tip: {
        id: 'claim-related.tip',
        defaultMessage: 'Tip: '
    },

    searchFilterHeading: {
        id: 'claim-related.searchFilterHeading',
        defaultMessage: 'You can search by document category, document description, document source, sender or date posted:'
    },
    dropDownSelectLabel: {
        id: 'claim-related.dropDownSelectLabel',
        defaultMessage: 'Choose how you want to search:'
    },
    dropdownPlaceholder: {
        id: 'claim-related.dropdownPlaceholder',
        defaultMessage: 'Search all'
    },
    searchLabel: {
        id: 'claim-related.searchLabel',
        defaultMessage: 'Enter search term:'
    },
    searchPlaceholder: {
        id: 'claim-related.searchPlaceholder',
        defaultMessage: 'Start typing to search'
    },
    moreSearchHeading: {
        id: 'claim-related.moreSearchHeading',
        defaultMessage: 'More search options'
    },
    selectDownloadText: {
        id: 'claim-related.selectDownloadText',
        defaultMessage: 'Select up to 5 documents for download'
    },
    downloadBtnText: {
        id: 'claim-related.downloadBtnText',
        defaultMessage: 'Download selected documents'
    },
    dropDownDocumentCategory: {
        id: 'claim-related.documentCategory',
        defaultMessage: 'Document category'
    },
    dropDownDocumentDescription: {
        id: 'claim-related.documentDescription',
        defaultMessage: 'Document description'
    },
    dropDownDateReceived: {
        id: 'claim-related.dateReceived',
        defaultMessage: 'Date posted'
    },
    dropDownDocumentSource: {
        id: 'claim-related.documentSource',
        defaultMessage: 'Document source'
    },
    dropDownDocumentSender: {
        id: 'claim-related.documentSender',
        defaultMessage: 'Sender'
    },
    datatableHeaderdocumentCategory: {
        id: 'claim-related.datatable.header.documentCategory',
        defaultMessage: 'Document category'
    },
    datatableHeaderDocumentDescription: {
        id: 'claim-related.datatable.header.documentDescription',
        defaultMessage: 'Document description'
    },
    datatableHeaderDocumentSource: {
        id: 'claim-related.datatable.header.documentSource',
        defaultMessage: 'Document source'
    },
    datatableHeaderSender: {
        id: 'claim-related.datatable.header.sender',
        defaultMessage: 'Sender'
    },
    datatableHeaderDateReceived: {
        id: 'claim-related.datatable.header.dateReceived',
        defaultMessage: 'Date posted'
    },
    datatableNdDataText: {
        id: 'claim-related.datatable.nodatatext',
        defaultMessage: 'There is no information to display'
    },
    datatableServerError: {
        id: 'claim-related.datatable.servererror',
        defaultMessage: 'We couldn’t get your documents because of a technical problem. Please reload the page.'
    },
    arialabelFieldModal: {
        id: 'claim-related.arialabelFieldModal',
        defaultMessage: 'Enter correct information and fill at least one field before searching.'
    },
    checkInformation: {
        id: 'claim-related.checkInformation',
        defaultMessage: 'Make sure all the information you enter is correct. Fill in at least one of the fields below before clicking ‘Search’.'
    },
    documentCategoryLabel: {
        id: 'claim-related.documentCategoryLabel',
        defaultMessage: 'Document category:'
    },
    chooseOneOption: {
        id: 'claim-related.chooseOneOption',
        defaultMessage: 'Choose one'
    },
    documentDescriptionLabel: {
        id: 'claim-related.documentDescriptionLabel',
        defaultMessage: 'Document description:'
    },
    channelLabel: {
        id: 'claim-related.documentSourceLabel',
        defaultMessage: 'Document source:'
    },
    dateReceivedLabel: {
        id: 'claim-related.datePostedLabel',
        defaultMessage: 'Date posted:'
    },
    fromDateLabel: {
        id: 'claim-related.fromDateLabel',
        defaultMessage: 'From: (YYYY-MM-DD)'
    },
    toDateLabel: {
        id: 'claim-related.toDateLabel',
        defaultMessage: 'To: (YYYY-MM-DD)'
    },
    fewerSearchOtions: {
        id: 'claim-related.fewerSearchOtions',
        defaultMessage: 'Fewer search options'
    },
    senderLabel: {
        id: 'claim-related.senderLabel',
        defaultMessage: 'Sender:'
    },
    dateTooltipHeading: {
        id: 'claim-related.dateTooltipHeading',
        defaultMessage: 'Date selection'
    },
    dateTooltipContent1: {
        id: 'claim-related.dateTooltipContent1',
        defaultMessage: 'Select a ‘From’ date to show records from that date forward.'
    },
    dateTooltipContent2: {
        id: 'claim-related.dateTooltipContent2',
        defaultMessage: 'Select a ‘To’ date to show records up to and including that date.'
    },
    dateTooltipContent3: {
        id: 'claim-related.dateTooltipContent3',
        defaultMessage: 'Select a ‘From’ date and a ‘To’ date to show records within that date range.'
    },
    fieldNameTooltipHeading: {
        id: 'claim-related.fieldNameTooltipHeading',
        defaultMessage: 'Explanation of field names'
    },
    fieldNameTooltipContent1: {
        id: 'claim-related.fieldNameTooltipContent1',
        defaultMessage: 'Document description: The type of document for example, a form, letter, or health care report.'
    },
    fieldNameTooltipContent2: {
        id: 'claim-related.fieldNameTooltipContent2',
        defaultMessage: 'Document category: The topic or purpose of the document, for example, medical, payment, return to work, or general correspondence.'
    },
    fieldNameTooltipContent3: {
        id: 'claim-related.fieldNameTooltipContent3',
        defaultMessage: 'Sender: The organization or role of the person that sent the document.'
    },
    fieldNameTooltipContent4: {
        id: 'claim-related.fieldNameTooltipContent4',
        defaultMessage: 'Date posted: The date the document appeared in our system, or the date the document was added to your claim.'
    },
    fieldNameTooltipContent5: {
        id: 'claim-related.fieldNameTooltipContent5',
        defaultMessage: 'Document source: How the WSIB received the document. For example, online, fax, business-to-business.'
    },
    noDataFoundinAdvanceSearch: {
        id: 'claim-related.noDataFoundinAdvanceSearch',
        defaultMessage: 'We didn’t find any results for your search.'
    },
    MSG10: {
        id: 'claim-related.datatable.MSG10',
        defaultMessage: 'Please enter search criteria to continue.'
    },
    MSG17: {
        id: 'claim-related.datatable.MSG17',
        defaultMessage: 'We didn’t find any results for your search.'
    },
    MSG11: {
        id: 'claim-related.datatable.MSG11',
        defaultMessage: 'There are no filters currently applied.'
    },
    invalidFromDateError: {
        id: 'claim-related.invalidFromDateError',
        defaultMessage: 'Invalid date format. Please enter the date in YYYY-MM-DD'
    },
    invalidToDateError: {
        id: 'claim-related.invalidToDateError',
        defaultMessage: 'Invalid date format. Please enter the date in YYYY-MM-DD'
    },
    earlierFromDateError: {
        id: 'claim-related.earlierFromDateError',
        defaultMessage: 'Please select a \'From\' date that is earlier than the \'To\' date.'
    },
    showMoreAriaLabel: {
        id: 'claim-related.showMoreAriaLabel',
        defaultMessage: 'Show more search options'
    },
    showFewerAriaLabel: {
        id: 'claim-related.showFewerAriaLabel',
        defaultMessage: 'Hide some of the search options'
    },
    documentCategoryAriaLabel: {
        id: 'claim-related.documentCategoryAriaLabel',
        defaultMessage: 'Choose one document category'
    },
    documentSourceAriaLabel: {
        id: 'claim-related.documentSourceAriaLabel',
        defaultMessage: 'Choose one document source'
    },
    checkInfoAriaLabel: {
        id: 'claim-related.checkInfoAriaLabel',
        defaultMessage: 'Enter correct information and fill at least one field before searching.'
    },
    searchButtonAriaLabel: {
        id: 'claim-related.searchButtonAriaLabel',
        defaultMessage: 'Search claim-related documents'
    },
    resetButtonAriaLabel: {
        id: 'claim-related.resetButtonAriaLabel',
        defaultMessage: 'Reset the search'
    },
    downloadbtnFilter: {
        id: 'claim-related.downloadbtnFilter',
        defaultMessage: 'Download selected documents'
    },
    MSG16: {
        id: 'claim-related.MSG16',
        defaultMessage: 'Download has started'
    },
    MSG18: {
        id: 'claim-related.MSG18',
        defaultMessage: 'You have selected 5 documents. This is the maximum allowed.'
    },
    MSG24: {
        id: 'claim-related.MSG24',
        defaultMessage: 'Another download cannot be started while one is already in progress.'
    },
    MSG25: {
        id: 'claim-related.MSG25',
        defaultMessage: 'Please select a document to download'
    },
    closePopUp: {
        id: 'claim-related.closePopUp',
        defaultMessage: 'Click the button to close this popup message.'
    },
    limitReachedWarning: {
        id: 'claim-related.limitReachedWarning',
        defaultMessage: 'Limit reached. You can select five documents to download.'
    },
    tooManyFilesError: {
        id: 'claim-related.tooManyFilesError',
        defaultMessage: 'You have selected too many files'
    },
    MSG19: {
        id: 'claim-related.MSG19',
        defaultMessage: 'You may select up to five documents to download.'
    },
    multiDownloadModalTitle: {
        id: 'claim-related.multiDownloadModalTitle',
        defaultMessage: 'Some files couldn’t be downloaded'
    },
    noofDocumentsDownloadedmsg: {
        id: 'claim-related.noofDocumentsDownloadedmsg',
        defaultMessage: 'documents were downloaded. Please try again.'
    },
    waitforDownloadModalTitle: {
        id: 'claim-related.waitforDownloadModalTitle',
        defaultMessage: 'Wait for your current download to finish before starting another',
    },
    waitforDownloadModalContent: {
        id: 'claim-related.waitforDownloadModalContent',
        defaultMessage: 'You may select up to five documents to download.',
    },
    closeText: {
        id: 'claim-related.closeText',
        defaultMessage: 'Close'
    },
    basicLimitWarning: {
        id: 'claim-Related.basicLimitWarning',
        defaultMessage: 'Too many documents to filter using Basic search. Please try Advanced search.'
    },
    msg40ScrubDoctitle: {
        id: 'claim-Related.Msg40ScrubDoc.title',
        defaultMessage: 'This file is available by request'
    },
    msg40ScrubDocContent: {
        id: 'claim-Related.Msg40ScrubDoc.content',
        defaultMessage: 'Send us a message with the document category, the document description or file name and the date posted and we’ll make it available for you.'
    },
    msg41ScrubDoctitle: {
        id: 'claim-Related.Msg41ScrubDoc.title',
        defaultMessage: 'Some files are available by request'
    },
    msg41ScrubDocContent: {
        id: 'claim-Related.Msg41ScrubDoc.content',
        defaultMessage: '{outcome}/{total} documents were downloaded. To request the files that weren’t downloaded, send us a message with the document category, the document description or file name and the date posted and we’ll make it available for you.'
    },
});
